import React from 'react';
import './loader.css';

const LocalLoader = ({className=""}) => {
	return (
		<>
			<div className={`wrapper-loader ${className}`}>
				<div className="loader"></div>
			</div>
		</>
	);
};
export default LocalLoader;
